'use strict';

const $ = window.jQuery;

export default class SocialSharer {
    constructor() {
        $('.toggle-socials').on('click', function () {
            $(this).closest('.social-sharer').toggleClass('deployed');
        });
    }
}
